var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8246",
    "data-name": "Group 8246",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-oo",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171e2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3206",
    "data-name": "Group 3206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3205",
    "data-name": "Group 3205",
    transform: "translate(16.805 9.048)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u20B9",
    transform: "translate(3 12)",
    fill: "#ffc165",
    fontSize: 12,
    fontFamily: "Lexend-Regular, Lexend"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.24,
    y: 0
  }, "\u20B9"))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_743",
    "data-name": "Ellipse 743",
    fill: "none",
    stroke: "#FAA381",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3215",
    "data-name": "Group 3215",
    transform: "translate(3.878 3.878)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 22.622,
    cy: 22.622,
    r: 22.622,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-lock",
    "data-name": "Icon awesome-lock",
    d: "M16.84,9.43h-1.01V6.4a6.4,6.4,0,0,0-12.8,0V9.43H2.021A2.021,2.021,0,0,0,0,11.451v8.083a2.021,2.021,0,0,0,2.021,2.021H16.84a2.021,2.021,0,0,0,2.021-2.021V11.451A2.021,2.021,0,0,0,16.84,9.43Zm-4.378,0H6.4V6.4a3.031,3.031,0,0,1,6.062,0Z",
    transform: "translate(13.192 11.844)",
    fill: "#FAA381"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.29725ad2.svg";
export { ForwardRef as ReactComponent };